import { LandingRootComponent } from './landing-root/landing-root.component';
import { LandingComponent } from './landing/landing.component';
import { CanActivateLanding } from '../services/canActivateLanding.service';
import { HowItWorksComponent } from './how-it-works/how-it-works.component';
import { ProductComponent } from './product/product.component';
import { LandingFaqComponent } from './faq/faq.component';
import { MagicAiComponent } from './magic-ai/magic-ai.component';
import { StyleguideComponent } from './styleguide/styleguide.component';
import { CanActivateStyleguide } from '../services/canActivateStyleguide.service';
import { TermsComponent } from './terms/terms.component';
import { PrivacyComponent } from './privacy/privacy.component';

export const routes = [
  {
    path: '',
    component: LandingRootComponent,
    children: [
      { path: '', component: LandingComponent },
      { path: 'product', component: ProductComponent },
      { path: 'how_it_works', component: HowItWorksComponent },
      { path: 'faq', component: LandingFaqComponent },
      { path: 'magic_ai', component: MagicAiComponent },
      { path: 'privacy_policy', component: PrivacyComponent },
      { path: 'terms_of_service', component: TermsComponent },
      {
        path: 'styleguide',
        component: StyleguideComponent,
        canActivate: [CanActivateStyleguide],
      }
    ],
    canActivate: [CanActivateLanding],
    data: {
      hideDefaultHeader: true,
    },
  },
];
